import {COL_IDS} from '../ReportGenerator/componenets/ReportList/consts';
import texts from '../ReportGenerator/texts';

export const ANALYTICS_REPORT_DIALOG = 'analytics-reports-dialog';

export const getHeaderColumns = () => [
    {id: COL_IDS.title, title: texts.reportName},
    {id: COL_IDS.baseForm, title: texts.baseForm},
    {id: COL_IDS.reportType, title: texts.typeColumn},
    {id: COL_IDS.userName, title: texts.createdBy},
    {id: COL_IDS.updateTime, title: texts.updated}
];

export const ADD_ANALYTICS_TO_MENU = 'ADDANALYTICSTOMENU';
